import React from "react";
import { useForm, QuestionField, styles, CreateAccountToggle } from "./Forms";

export default function CustomerDetails() {
  const {
    customerQuestions,
    answers,
    errors,
    setAnswer,
    applyLocation,
    goContinue,
    petCtxFor,
  } = useForm();

  return (
    <form onSubmit={(e) => e.preventDefault()} noValidate>
      <div className="ff-panel">
        {customerQuestions.length === 0 ? (
          <p style={styles.emptyText}>
            No details needed here. Continue to the next step.
          </p>
        ) : (
          <div className="ff-grid">
            {customerQuestions.map((q) => {
              if (q.answerType === "section_heading") {
                return (
                  <div
                    key={q._id}
                    className="ff-full"
                    style={styles.sectionHeading}
                  >
                    <h2 style={styles.sectionHeadingText}>{q.question}</h2>
                  </div>
                );
              }
              return (
                <QuestionField
                  key={q._id}
                  q={q}
                  fieldKey={q._id}
                  value={answers[q._id]}
                  error={errors[q._id]}
                  onChange={(v) => setAnswer(q, q._id, v)}
                  onLocate={(r) => applyLocation(r, q._id)}
                  petCtx={petCtxFor(0)}
                />
              );
            })}
          </div>
        )}
        {customerQuestions.length > 0 && <CreateAccountToggle />}
      </div>

      {/* Verification is its own page before this, so no Back button here */}
      <div className="ff-nav">
        <div className="ff-nav-inner">
          <button
            type="button"
            onClick={goContinue}
            style={{ ...styles.primaryBtn, flex: 1, marginTop: 0 }}
          >
            Continue to pet details
          </button>
        </div>
      </div>
    </form>
  );
}
